export default __webpack_public_path__ + "static/qubitro_logo-82de8469150ee482e5916bef26770d4d.svg";